module.exports = {
    language: {
        name: '中文'
    },
    navMenu: {
        home: 'Home',
        about: 'Exhibition',
        report: 'Academic',
        service: 'Exhibition services',
        download: 'Data download',
        contact: 'Contact us',
    },
    home: {
        top: 'Top', //回到顶部
        more: 'More', //更多
        latestNews: 'Latest News', //最新动态
        show: 'Enterprise Display', //企业展示
        exciting: 'Exciting Review', //精彩回顾
        mediaPartners: 'Media Partners',// 合作媒体
        booth: 'Booth', //展位号,
        newsMore:'Article List'
    },
}